/* eslint-disable no-nested-ternary */
import React from "react"
import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import Img from "./Img"
import ImgMedia from "./ImgMedia"
import ImgCeleba from "./ImgCeleba"
import { ButtonFloating } from "./ButtonFloating"
import * as styles from "./banner.module.scss"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"
import { TypeBannerPropsWithElements } from "../helpers"

const defaultTitle = `
До 36 месяцев рассрочки* и до 5 000 ₽ кэшбэка
`

const defaultSubtext = `
— Совершайте покупки в интернет-магазинах партнеров Халвы
— Крутите Колесо Фортуны на промо-странице и получайте бонусы от Халвы
`

export function Banner({
  buttonText = "Оформить карту",
  title = defaultTitle,
  description = defaultSubtext,
  orderNum,
  variantStyle,
  variant,
}: TypeBannerPropsWithElements) {
  const genderActionMedia = variant === "genderMedia" || variant === "genderMediaGetHalva"
  const genderCelebaMedia = variant === "genderCeleba"
  return (
    <>
      <section
        className={clsx(styles.section, variantStyle && styles[variantStyle])}
        data-exclude={orderNum}
        id="banner"
      >
        <Container className={styles.container}>
          <div className={styles.secondContainer}>
            {genderActionMedia ? (
              <ImgMedia alt="bg image" className={styles.img} />
            ) : genderCelebaMedia ? (
              <ImgCeleba alt="bg image" className={styles.img} />
            ) : (
              <Img alt="bg image" className={styles.img} />
            )}
            <div className={styles.text}>
              {typeof title === "string" ? (
                <h1 dangerouslySetInnerHTML={{ __html: title }} />
              ) : (
                <h1>{title}</h1>
              )}
              {typeof description === "string" ? (
                <div dangerouslySetInnerHTML={{ __html: description }} />
              ) : (
                <div>{description}</div>
              )}
            </div>
            <Button className={styles.btn} onClick={() => handleClickBanner(buttonText, title)}>
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <ButtonFloating variantStyle={variant} onClick={handleClickStickyBtn}>
        Оформить карту
      </ButtonFloating>
    </>
  )
}
